import React, { Component } from "react";
import _ from "lodash";
import dayjs from "dayjs";
// import { Link } from "react-router-dom";
import { withRedux } from "../hoc";
import { Button, Slider } from ".";

const mapStateToProps = ({ language, t }) => {
  return {
    language,
    t,
  };
};

@withRedux(mapStateToProps)
export default class ShowTimes extends Component {
  render() {
    const { showtimes, t } = this.props;
    return (
      <div className="showtimes-component">
        <div className="render-desktop d-none d-md-block">
          <div className="showtimes-menu">
            <h1>Daily Showtimes</h1>
            <div className="container-get-ticket">
              {_.map(showtimes, (item, key) => {
                const date = dayjs(_.get(item, "showTime")).format("HH:mm");
                // const today = dayjs().format("YYYY/MM/DD");
                return (
                  <div className="showtimes-data" key={key}>
                    <div className="time-show">{date}</div>
                    <a
                      href="http://tiffany.cloudapp.net/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button size="large">{t("Purchase Tickets")}</Button>
                    </a>
                    {/* <Link to={`booking?date=${today}&showtimeId=${_.get(item, "showTimeID")}`}>
                      <Button size="large">{t("Purchase Tickets")}</Button>
                    </Link> */}
                    {_.get(item, "available") < 100 && (
                      <div className="seat-avaliable">
                        {_.get(item, "available")} seats left
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          {/* <div className="showtimes-menu">
            <div className="row align-items-center">
              <div className="col-lg-4" style={{ zIndex: 1 }}>
                <h1>Extra Showtimes</h1>
              </div>
              <div className="col-lg-8">
                <div className="container-get-ticket">
                  {_.map(extraShowtimes, (item, key) => {
                    return (
                      <div className="showtimes-data" key={key}>
                        <div className="time-show">{item.times}</div>
                        <Button size="large">{t("Purchase Tickets")}</Button>
                        <div className="seat-avaliable">{item.seats} seats left</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="render-mobile d-md-none">
          <div className="showtimes-menu">
            <h1>Daily Showtimes</h1>
            <Slider
              items={showtimes}
              settings={{
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 1.5,
              }}
              uiRenderer={(item, key) => {
                const date = dayjs(_.get(item, "showTime")).format("HH:mm");
                // const today = dayjs().format("YYYY/MM/DD");
                return (
                  <div className="showtimes-data" key={key}>
                    <div className="time-show">{date}</div>
                    <a
                      href="http://tiffany.cloudapp.net/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button size="large">{t("Purchase Tickets")}</Button>
                    </a>
                    {/* <Link to={`booking?date=${today}&showtimeId=${_.get(item, "showTimeID")}`}>
                      <Button size="large">{t("Purchase Tickets")}</Button>
                    </Link> */}
                    {_.get(item, "available") < 100 && (
                      <div className="seat-avaliable">
                        {_.get(item, "available")} seats left
                      </div>
                    )}
                  </div>
                );
              }}
            />
          </div>
          {/* <div className="showtimes-menu extra">
            <h1>Extra Showtimes</h1>
            <Slider
              items={extraShowtimes}
              settings={{
                arrows: false,
                dots: true,
                infinite: false,
                slidesToShow: 1.5
              }}
              uiRenderer={(item, key) => {
                return (
                  <div className="showtimes-data" key={key}>
                    <div className="time-show">{item.times}</div>
                    <Button size="large">{t("Purchase Tickets")}</Button>
                    <div className="seat-avaliable">{item.seats} seats left</div>
                  </div>
                );
              }}
            />
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShowTimes.js